import type { Faq } from '../types/content'

export const faqs: Faq[] = [
  {
    question: 'How long does a project actually take?',
    answer:
      'A full website is booked as a fixed schedule you get on day one. The only thing that moves the date is feedback arriving late, so we agree review windows up front — 48 hours per round.',
  },
  {
    question: 'What do you need from us to start?',
    answer:
      'One decision-maker who can attend four calls, whatever brand assets exist, and access to your current site and analytics. If the copy does not exist yet, we write it — that is included in Strategy, not an add-on.',
  },
  {
    question: 'Which platform will you build on?',
    answer:
      'Webflow or Framer for marketing sites, Shopify for commerce, Next.js when there is real product logic involved, WordPress when your team already lives there. We recommend during Discovery based on who maintains the site after we leave, not on what we feel like building.',
  },
  {
    question: 'How many rounds of feedback do I get?',
    answer:
      'The number of feedback rounds is agreed in the Scope of Work before the project starts, so it is fixed and in writing from day one. Feedback is collected in one consolidated pass per round, which is faster for you and produces better decisions than a stream of separate notes.',
  },
  {
    question: 'Can we edit the site ourselves afterwards?',
    answer:
      'The CMS is set up so you can edit text and images yourself. We record a short walkthrough at handover.',
  },
  {
    question: 'What does support look like after launch?',
    answer:
      'Thirty days of fixes, small changes and questions answered within one working day, at no extra cost. After that you can stay on a monthly care plan, or simply email us when something comes up.',
  },
]
